import { useContext } from "react";
import { CollectionsContext } from "../../../components/root/CollectionsProvider";

type TitleChoice = { value: string; text: string; color?: string };

export const useNoteTitleChoices = () => {
	const collections = useContext(CollectionsContext);
	const titleField = collections?.fields.find((f) => f.collection === "notes" && f.field === "title") as any;
	return (titleField?.meta?.options?.choices ?? []) as Array<TitleChoice>;
};
